import React from 'react';
import Header from '../components/Header';
import SideBar from '../components/SideBar';
import Footer from '../components/Footer';
import BtnToTop from '../components/BtnToTop';
import MainContent from '../components/MainContent';
import axios from 'axios';

const HomePage = ({ onLogout }) => {
  // Mengatur interceptor di sini
  axios.interceptors.request.use(
    (config) => {
      const access_token = localStorage.getItem('access_token');
      if (access_token) {
        config.headers['access_token'] = access_token; // Menambahkan token ke headers
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  return (
    <>
      <Header onLogout={onLogout} />
      <SideBar />
      <MainContent />
      <Footer />
      <BtnToTop />
    </>
  );
};

export default HomePage;
